/**
 * User-facing label per raw test-run status, shared by the failures table and
 * the attempt-history rows. Note that `success` and `flaky_success` both read
 * as "Passed" — the status filter groups by label for exactly that reason.
 */
export const testRunLabelMap: Record<string, string> = {
  queued: 'Queued',
  running: 'Running',
  waiting: 'Waiting',
  success: 'Passed',
  failed: 'Failed',
  inconclusive: 'Platform error',
  skipped: 'Skipped',
  degraded: 'Degraded',
  flaky_success: 'Passed',
  canceled: 'Canceled',
  timeout: 'Timed Out',
};
